import layoutHeaderAside from '@/layout/header-aside'
import bus from '@/components/view-bus'
// import bus from '@/components/view-bus'
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)
// 信鸽路由
export default [
  {
    path: '/center',
    name: 'center',
    meta: {
      title: '个人中心',
      auth: true
    },
    // component: _import('payfee/prepay')
    redirect: { name: 'CenterIndex' },
    component: layoutHeaderAside,
    children: [
      {
        path: 'index',
        name: 'CenterIndex',
        meta: {
          title: '个人中心',
          auth: true
        },
        component: _import('center/index')
      },
      // {
      //   path: 'index',
      //   name: 'CenterIndex',
      //   meta: {
      //     title: '赛事中心',
      //     auth: true
      //   },
      //   component: _import('match/index')
      // },
      {
        path: 'phone',
        name: 'Phone',
        meta: {
          title: '更换手机号',
          auth: true
        },
        component: _import('center/phone')
      },
      {
        path: 'password',
        name: 'Password',
        meta: {
          title: '修改密码',
          auth: true
        },
        component: _import('center/password')
      }
    ]
  }
]
